/** URL publique de la page entreprise LinkedIn (E-E-A-T / confiance). */
export const UPREALITY_LINKEDIN_COMPANY_URL =
  "https://www.linkedin.com/company/upreality-social-landing-pages/";

/** Dégradé texte du logo UpReality (turquoise → cyan → bleu océan). */
export const UPREALITY_LOGO_TEXT_GRADIENT =
  "linear-gradient(to right, #6dd4a7 0%, #3ba8c5 50%, #2672b6 100%)";

export const UPREALITY_LOGO_TEXT_STYLE = {
  background: UPREALITY_LOGO_TEXT_GRADIENT,
  WebkitBackgroundClip: "text",
  backgroundClip: "text",
  WebkitTextFillColor: "transparent",
  color: "transparent",
};
